import { render } from "./SemesterModulesModal.vue?vue&type=template&id=3aca7751&scoped=true"
import script from "./SemesterModulesModal.vue?vue&type=script&lang=js"
export * from "./SemesterModulesModal.vue?vue&type=script&lang=js"

import "./SemesterModulesModal.vue?vue&type=style&index=0&id=3aca7751&scoped=true&lang=css"
import "./SemesterModulesModal.vue?vue&type=style&index=1&id=3aca7751&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aca7751"]])

export default __exports__